/**
 * Styled Components - Created by eduardoquintero on 07/05/19.
 */
import { DatePicker, Select, Spin } from 'antd'
import Icon from 'antd/lib/icon'
import Button from 'antd/lib/button'
import Search from 'antd/lib/input/Search'
import Checkbox from 'antd/lib/checkbox'
import styled from 'styled-components'
import {
  BLUE,
  GRAY_DARK,
  GRAY_STRONG,
  RED,
  WHITE,
  WHITE_SMOKE,
  WHITE_TRANSPARENT,
} from '../../theme/colors'

const Option = Select.Option

interface ButtonWrapperProps {
  disabled: boolean
}

export const Container = styled.div`
  width: 100%;
  margin-bottom: 32px;
  position: relative;
`

export const Title = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 28px;
  margin-top: 2px;
  display: flex;
  align-items: center;
  width: 97%;
  @media (max-width: 698px) {
    display: none;
  }
`

export const Filters = styled.div`
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 97%;
  width: 100%;
  flex-flow: column;
  box-shadow: 0px 2px 4px 1px #e6e6e6;
  display: block;
  border-radius: 3px;
  padding: 18px 20px;
  margin-bottom: 22px;
  padding-bottom: 20px;
  border-top: 1px solid #ececec;
  @media (max-width: 698px) {
    flex-wrap: wrap
    margin-bottom: 20px;
    display: none;
  }
`

export const FilterSelect = styled(Select)`
  flex: 1;
  margin-right: 16px;
  .ant-select-selection {
    height: 42px;
    padding-top: 6px;
    border-radius: 3px;
  }
  .ant-select-selection__clear {
    right: 28px;
  }
  @media (max-width: 698px) {
    width: 44%;
    flex: unset;
    margin-bottom: 12px;
  }
`

export const SearchInput = styled(Search)`
  border-radius: 3px;
  max-width: 338px;
  width: 100%;
  margin-right: 16px;
  & input {
    border-radius: 3px;
    padding: 7px;
    height: 42px;
  }
  @media (max-width: 698px) {
    width: 100%;
  }
`

export const FilterOption = styled(Option)``

export const LoadingDiv = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: ${WHITE_TRANSPARENT};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .25s;
  animation: fade-in-top 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-1px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const LoadingSpin = styled(Spin)`
  margin-top: 10px;
`

export const StyledDatePicker = styled(DatePicker)`
  flex: 1;
  height: 42px;
  margin-right: 15px;
  input {
    border-radius: 3px;
    height: 42px;
  }
  @media (max-width: 698px) {
    width: 44%;
    flex: unset;
    margin-bottom: 12px;
  }
`

export const CsvDiv = styled.div`
  display: inline-flex;
  margin-left: 14px;
  margin-right: 10px;
  flex-flow: column;
  font-size: 10px;
  transition: all .25s;
  text-align: center;
  .ant-spin {
    margin-top: 7px;
  }
  &:hover {
    cursor: pointer;
    color: ${RED};
    .anticon {
      color: ${RED};
    }
  }
`

export const CsvIcon = styled(Icon)`
  font-size: 22px;
  margin-bottom: 6px;
  transition: all .25s;
  color: ${GRAY_STRONG};
`

export const FiltersTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
  font-family: Avenir;
  margin-bottom: 12px;
`

export const Inputs = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 698px) {
    flex-wrap: wrap;
  }
`

export const ButtonWrapper = styled.div`
  max-width: 100px;
  width: 100%;
  .ant-btn-primary {
    background-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
  }
  .ant-btn-primary:hover {
    background-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
  }
  @media (max-width: 698px) {
    width: 100%;
    max-width: 100%;
    margin-top: 8px;
  }
`

export const StyledButton = styled(Button)`
  height: 40px;
  border-radius: 3px;
  width: 100%;
  @media (max-width: 698px) {
    width: 95%;
  }
`

export const BottomFitlers = styled.div`
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 97%;
  padding-right: 46px;
  @media (max-width: 698px) {
    width: 100%;
    padding-right: 16px;
    display: none;
  }
`

export const TestPrintIcon = styled(Icon)`
  font-size: 18px;
  margin-right: 12px;
  margin-bottom: -2px;
`

export const ActionButtons = styled.div`
  display: flex;
  width: 97%;
  align-items: center;
  justify-content: space-between;
  margin-top: 26px;
  margin-bottom: 18px;
`

export const AddNewTicket = styled.div`
  border: 1px solid ${BLUE};
  padding: 8px 12px;
  border-radius: 3px;
  color: ${BLUE};
  background: ${WHITE};
  box-shadow: 1px 2px 3px 0px #e3e3e3;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${BLUE};
    color: ${WHITE};
  }
`

export const StyledCheckbox = styled(Checkbox)`
  color: ${GRAY_DARK};
  font-size: 14px;
  line-height: 22px;
  &.ant-checkbox-wrapper {
    margin-left: 0px;
  }
`

export const ArchiveHeaderIcon = styled(Icon)`
  font-size: 14px;
  color: #d7a462;
`

export const Table = styled.table`
  border-collapse: collapse;
  width: 97%;
  margin-bottom: 24px;
  position: relative;
  margin-top: 14px;
`

export const Row = styled.tr``

export const LoadingContainer = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  padding-top: 48px;
  background: #ffffffa3;
  z-index: 2;
  animation: fade-in 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const PaginationDiv = styled.div`
  width: 97%;
  text-align: right;
`

export const InfoDiv = styled.div`
  color: ${BLUE};
  position: absolute;
  right: 36px;
  top: 0;
  transition: all .25s;
  @media (max-width: 698px) {
    position: unset;
    margin-top: -10px;
    margin-right: 4px;
    text-align: center;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const InfoIcon = styled(Icon)`
  display: inline-flex;
  margin-right: 8px;
  font-size: 13px;
`

export const ModalTitleDisabled = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const IconPrint = styled(Icon)`
  margin-right: 12px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const InfoSection = styled.div`
  display: flex;
  margin-bottom: 28px;
  @media (max-width: 698px) {
    flex-flow: column;
    align-items: center;
    margin-bottom: 0px;
  }
`

export const DescriptionSection = styled.div`
  margin-left: 32px;
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 14px;
  }
`

export const InfoImage = styled.img`
  max-width: 220px;
  border-radius: 3px;
`

export const InfoSub = styled.div`
  font-size: 14px;
  font-family: Avenir;
`

export const SmallInfo = styled.div`
  font-size: 11px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
  font-family: Avenir;
  margin-bottom: 18px;
`

export const GoodReasons = styled.div`
  font-weight: bold;
  font-family: Avenir;
  margin: 12px 0;
  @media (max-width: 698px) {
    margin-top: 8px;
  }
`

export const ReasonsList = styled.div`
  font-size: 14px;
  font-family: Avenir;
  ul {
    padding-left: 18px;
  }
  li {
    margin-bottom: 8px;
  }
`

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TestPrintList/styledComponents.tsx